import { uiText } from "@/lib/i18n/uiText";
import { Home, ListChecks, TrendingUp, Trophy, Shield, UserRound } from "lucide-react";
import { Link, useLocation } from "@/lib/router-compat";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { authPath } from "@/lib/authRedirect";

const ITEMS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/predictions", label: "Picks", icon: ListChecks },
  { to: "/safe-bets", label: "Safe Bets", icon: Shield },
  { to: "/high-odds", label: "High Odds", icon: TrendingUp },
  { to: "/track-record", label: "Results", icon: Trophy },
];

/** Thumb-reach navigation for phones; hidden from tablet width upward. The full menu lives behind the top-left button. */
export function BottomNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const itemClass =
    "flex flex-1 flex-col items-center justify-center gap-0.5 min-h-14 text-[11px] font-medium transition-colors";
  return (
    <nav
      aria-label={uiText("Quick navigation")}
      className="md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur-xs pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="flex">
        {ITEMS.map(({ to, label, icon: Icon }) => {
          const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <li key={to} className="flex flex-1">
              <Link
                to={to}
                aria-current={active ? "page" : undefined}
                className={cn(itemClass, active ? "text-primary" : "text-muted-foreground hover:text-foreground")}
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
                {uiText(label)}
              </Link>
            </li>
          );
        })}
        <li className="flex flex-1">
          <Link
            to={user ? "/profile" : authPath("/profile")}
            aria-current={pathname.startsWith("/profile") ? "page" : undefined}
            className={cn(itemClass, pathname.startsWith("/profile") ? "text-primary" : "text-muted-foreground hover:text-foreground")}
          >
            <UserRound className="h-5 w-5" aria-hidden="true" />
            {uiText("Profile")}
          </Link>
        </li>
      </ul>
    </nav>
  );
}
